(function () {
  const htmlLang = document.documentElement.getAttribute('lang') || '';
  const path = globalThis.location.pathname.replace(/\/+$/, '');

  if (!/^de\b/i.test(htmlLang) || !/^(\/de)?\/pages\/vacuslim$/.test(path)) {
    return;
  }

  const translations = [
    ['View Professional Sets', 'Professionelle Sets ansehen'],
    ['One Professional System. Visible Body Contouring Results.', 'Ein professionelles System. Sichtbare Ergebnisse bei der Körperformung.'],
    ['Structured body contouring for measurable aesthetic improvements.', 'Strukturierte Körperformung für messbare ästhetische Verbesserungen.'],
    ['Vacuslim 48 is a professional Sculpt & Remodeling System designed for salons that want visible, measurable body contour changes without devices and without forcing the body.', 'Vacuslim 48 ist ein professionelles Sculpting- und Remodeling-System für Institute, die sichtbare und messbare Veränderungen der Körperkontur erzielen möchten, ohne Geräte und ohne den Körper zu belasten.'],
    ['Visible and measurable improvements are often observed from the first treatment and continue progressively throughout the treatment series.', 'Sichtbare und messbare Verbesserungen werden oft bereits nach der ersten Behandlung beobachtet und setzen sich im Verlauf der Behandlungsserie schrittweise fort.'],
    ['GET PROFESSIONAL ACCESS', 'PROFESSIONELLEN ZUGANG ERHALTEN'],
    ['VIEW PROFESSIONAL SETS', 'PROFESSIONELLE SETS ANSEHEN'],
    ['Why Professional Access? Unlock special offers, trainings and guides with Professional Access', 'Warum professioneller Zugang? Schalten Sie Sonderangebote, Schulungen und Leitfäden mit dem professionellen Zugang frei.'],
    ['Warum Professional Access? Schalten Sie mit Professional Access Sonderangebote, Schulungen und Leitfäden frei', 'Warum professioneller Zugang? Schalten Sie Sonderangebote, Schulungen und Leitfäden mit dem professionellen Zugang frei.'],
    ['Trusted by professional salons worldwide.', 'Von professionellen Instituten weltweit geschätzt.'],
    ['OVER 10,000 PROFESSIONALS HAVE CHOSEN VACUSLIM 48', 'MEHR ALS 10.000 PROFIS HABEN SICH FÜR VACUSLIM 48 ENTSCHIEDEN'],
    ['CELLULITE', 'CELLULITE'],
    ['Visible reduction in the appearance of cellulite', 'Sichtbare Reduktion des Erscheinungsbildes von Cellulite'],
    ['SCULPT & CONTOUR', 'FORMEN & KONTURIEREN'],
    ['Professional body sculpting and contouring results', 'Professionelle Ergebnisse bei Körperformung und Konturierung'],
    ['PROOF & TRUST', 'NACHWEIS & VERTRAUEN'],
    ['Proven results backed by professional testimonials', 'Nachgewiesene Ergebnisse, bestätigt durch professionelle Erfahrungsberichte'],
    ['What is Vacuslim 48', 'Was ist Vacuslim 48?'],
    ['Vacuslim 48 is a Sculpt & Remodeling System based on smart, controlled natural body activation.', 'Vacuslim 48 ist ein Sculpting- und Remodeling-System, das auf intelligenter, kontrollierter natürlicher Körperaktivierung basiert.'],
    ['Through SmartSculpt™ Technology, which combines specialized active formulations with a controlled vacuum environment, the system supports visible body contouring, improved definition, and smoother-looking skin.', 'Durch die SmartSculpt™ Technology, die spezialisierte aktive Formulierungen mit einer kontrollierten Vakuumumgebung kombiniert, unterstützt das System eine sichtbare Körperkonturierung, eine verbesserte Definition und ein glatter wirkendes Hautbild.'],
    ['No forcing', 'Keine Überbelastung'],
    ['No aggressive techniques', 'Keine aggressiven Techniken'],
    ['Controlled activation', 'Kontrollierte Aktivierung'],
    ['Repeatable professional process', 'Wiederholbarer professioneller Prozess'],
    ['Why Salons Choose Vacuslim 48 ?', 'Warum Institute Vacuslim 48 wählen?'],
    ['Clear results clients can see and measure', 'Klare Ergebnisse, die Kundinnen sehen und messen können'],
    ['Easy to sell as a structured program', 'Einfach als strukturiertes Programm anzubieten'],
    ['Supports repeat bookings', 'Fördert wiederkehrende Buchungen'],
    ['No devices or complex setup', 'Keine Geräte und keine komplexe Einrichtung'],
    ['Fits into everyday salon workflow', 'Lässt sich einfach in den Institutsalltag integrieren'],
    ['See what our professional partners are seing about the Vacuslim48 impact', 'Lesen Sie, was unsere professionellen Partner über die Wirkung von Vacuslim 48 sagen'],
    ['Sehen Sie, was unsere professionellen Partner über die Wirkung von Vacuslim48 sagen', 'Lesen Sie, was unsere professionellen Partner über die Wirkung von Vacuslim 48 sagen'],
    ['PROFESSIONAL BENEFITS / PROFITABILITY', 'PROFESSIONELLE VORTEILE / RENTABILITÄT'],
    ['Vacuslim 48 is designed as a results-driven body treatment that integrates easily into everyday salon workflow and supports structured treatment programs.', 'Vacuslim 48 wurde als ergebnisorientierte Körperbehandlung entwickelt, die sich einfach in den Institutsalltag integrieren lässt und strukturierte Behandlungsprogramme unterstützt.'],
    ['After completing the first set of 10 treatments, my body shape finally achieved the result I wanted. I am very grateful to my beautician for this system!', 'Nach der ersten Serie von 10 Behandlungen hat meine Körperform endlich das Ergebnis erreicht, das ich mir gewünscht habe. Ich bin meiner Kosmetikerin für dieses System sehr dankbar!'],
    ['Vacuslim 48 is a total game changer for our Spa and Thermal Wellness resort. A must recommendation. After just one session, clients can see significant visible circumference refinement in circumference. In our treatments we use Vacuslim 48 concept and clients are more than satisfied. We have been working together for a long time.', 'Vacuslim 48 ist ein echter Gamechanger für unser Spa- und Thermal-Wellness-Resort. Eine klare Empfehlung. Schon nach nur einer Sitzung sehen Kundinnen und Kunden eine deutliche sichtbare Umfangsreduktion. In unseren Behandlungen nutzen wir das Vacuslim-48-Konzept, und die Kundinnen und Kunden sind mehr als zufrieden. Wir arbeiten bereits seit langer Zeit zusammen.'],
    ['I have been following Vacuslim 48 since the very first line in 2019, when I first ordered a starter version. I am thrilled with this concept. I use it in my salon and on my body and I really recommend it to everyone. I usually had issues with cellulite and water retention. After 3 sessions I noticed a huge difference in the appearance of my skin.', 'Ich verfolge Vacuslim 48 seit der allerersten Linie im Jahr 2019, als ich zum ersten Mal eine Starter-Version bestellt habe. Ich bin von diesem Konzept begeistert. Ich nutze es in meinem Institut und an meinem eigenen Körper und empfehle es wirklich jedem. Ich hatte häufig Probleme mit Cellulite und Wassereinlagerungen. Nach 3 Sitzungen habe ich einen enormen Unterschied im Erscheinungsbild meiner Haut bemerkt.'],
    ['My beautician recommended me Vacuslim 48 to try. I have always struggled with volume, loose skin, and cellulite in my thighs and arms area. I went for a 10 treatment program and was surprised at the visible results. It was super easy, relaxing, and the results were noticeable right away.', 'Meine Kosmetikerin hat mir empfohlen, Vacuslim 48 auszuprobieren. Ich hatte immer mit Volumen, erschlaffter Haut und Cellulite an Oberschenkeln und Armen zu kämpfen. Ich habe ein Programm mit 10 Behandlungen gemacht und war von den sichtbaren Ergebnissen überrascht. Es war sehr einfach, entspannend, und die Ergebnisse waren sofort sichtbar.'],
    ['Documented visual example after 10 Vacuslim 48 treatments performed according to the professional protocol.', 'Dokumentiertes visuelles Beispiel nach 10 Vacuslim-48-Behandlungen, durchgeführt nach professionellem Protokoll.'],
    ['Photographs were taken under consistent conditions, including lighting, body position, and camera distance.', 'Die Fotos wurden unter gleichbleibenden Bedingungen aufgenommen, einschließlich Beleuchtung, Körperposition und Kameraabstand.'],
    ['Results reflect an individual outcome and may vary depending on the initial condition, treatment consistency, and lifestyle factors.', 'Die Ergebnisse zeigen einen individuellen Verlauf und können je nach Ausgangszustand, Regelmäßigkeit der Behandlungen und Lebensstil variieren.'],
    ['They should not be interpreted as guaranteed results.', 'Sie sollten nicht als garantierte Ergebnisse verstanden werden.'],
    ['Note:', 'Hinweis:'],
    ['Before & After', 'Vorher / Nachher'],
    ['Choose your Professional Set', 'Wählen Sie Ihr professionelles Set'],
    ['Choose the system that fits your salon volume and treatment goals.', 'Wählen Sie das System, das zu Ihrem Institutsvolumen und Ihren Behandlungszielen passt.'],
    ['VACUSLIM 48 SMART BOX', 'VACUSLIM 48 SMART BOX'],
    ['VACUSLIM 48 EXPERT BOX', 'VACUSLIM 48 EXPERT BOX'],
    ['START-UP', 'START-UP'],
    ['EXPERT-KIT', 'EXPERT-KIT'],
    ['PROFESSIONAL NON-INVASIVE BODY CARE KIT', 'PROFESSIONELLES NICHT-INVASIVES KÖRPERPFLEGE-KIT'],
    ['ADVANCED PROFESSIONAL BODY SHAPING KIT', 'FORTGESCHRITTENES PROFESSIONELLES BODY-SHAPING-KIT'],
    ['30 FULL BODY TREATMENTS INCLUDED - 30 body + 20 arm treatments, complete salon solution', '30 GANZKÖRPERBEHANDLUNGEN INKLUSIVE - 30 Körper- und 20 Armbehandlungen, komplette Lösung für Institute'],
    ['30 FULL BODY TREATMENTS INCLUDED', '30 GANZKÖRPERBEHANDLUNGEN INKLUSIVE'],
    ['Ideal for salons introducing professional body contouring — no machines or downtime required.', 'Ideal für Institute, die professionelle Körperkonturierung einführen möchten, ohne Maschinen und ohne Ausfallzeit.'],
    ['UP TO 50 FULL TREATMENT SESSIONS - 50 body treatments, high-volume professional set', 'BIS ZU 50 VOLLSTÄNDIGE BEHANDLUNGSSITZUNGEN - 50 Körperbehandlungen, professionelles Set für hohes Behandlungsvolumen'],
    ['UP TO 50 FULL TREATMENT SESSIONS', 'BIS ZU 50 VOLLSTÄNDIGE BEHANDLUNGSSITZUNGEN'],
    ['Designed for experienced salon professionals ready to elevate their body contouring service menu.', 'Entwickelt für erfahrene Institutsprofis, die ihr Angebot für Körperkonturierung erweitern möchten.'],
    ['Start working with a structured body contouring system designed for professional consistency and measurable aesthetic improvement.', 'Starten Sie mit einem strukturierten Körperformungssystem, das für professionelle Konsistenz und messbare ästhetische Verbesserungen entwickelt wurde.'],
    ['Ready to work with Vacuslim 48', 'Bereit, mit Vacuslim 48 zu arbeiten'],
    ['Loved by Community', 'Von der Community geliebt'],
    ['follow @vacuslim48', 'Folgen Sie @vacuslim48'],
    ['Instagram post with the caption:', 'Instagram-Beitrag mit der Bildunterschrift:'],
    ['Instagram post opens in a popup', 'Instagram-Beitrag wird in einem Popup geöffnet'],
    ['previous post', 'vorheriger Beitrag'],
    ['next post', 'nächster Beitrag'],
    ['Visit our Instagram profile', 'Unser Instagram-Profil besuchen'],
    ['Austria', 'Österreich'],
    ['Croatia', 'Kroatien'],
    ['Slovenia', 'Slowenien'],
    ['Serbia', 'Serbien']
  ];

  function translateText(text) {
    let translated = text;

    translations.forEach(function (pair) {
      if (translated.includes(pair[0])) {
        translated = translated.split(pair[0]).join(pair[1]);
      }
    });

    return translated;
  }

  function translateNode(node) {
    if (!node?.nodeValue?.trim()) {
      return;
    }

    const translated = translateText(node.nodeValue);
    if (translated !== node.nodeValue) {
      node.nodeValue = translated;
    }
  }

  function translateTree(root) {
    if (root.nodeType === Node.ELEMENT_NODE) {
      translateAttributes(root);
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          const parent = node.parentNode;
          if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(parent.nodeName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let textNode = walker.nextNode();
    while (textNode) {
      translateNode(textNode);
      textNode = walker.nextNode();
    }

    root.querySelectorAll?.('[alt], [aria-label], [title]').forEach(translateAttributes);
  }

  function translateAttributes(element) {
    ['alt', 'aria-label', 'title'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) {
        return;
      }

      const value = element.getAttribute(attribute);
      let translated = translateText(value);
      if (attribute === 'alt' && translated.includes('Instagram-Beitrag mit der Bildunterschrift:')) {
        translated = 'Instagram-Beitrag von Vacuslim 48';
      }
      if (translated !== value) {
        element.setAttribute(attribute, translated);
      }
    });
  }

  function run() {
    const main = document.getElementById('main') || document.body;
    translateTree(main);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        translateNode(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          translateNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          translateTree(node);
        }
      });
    });
  });

  observer.observe(document.getElementById('main') || document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();